import { getRequest } from '../services/requestHandler';
import { BsgHeadwear } from '../models';

// Model: TourApp.Data/Models/PlayerRegionLookup
export const getBsgHeadwear = async () => {
  const url = 'bsgheadwear/getbsgheadwears?activeOnly=true';
  const response = await getRequest<BsgHeadwear>('GetBsgHeadwear', url);
  return response;
};
